import {
    Drawer, Typography, Toolbar, IconButton, AppBar, Card, CardContent,
    CardMedia, Grid, Box, Button, TextField, Badge, Divider, Chip, Snackbar, Alert, Tabs, Tab,
    List, ListItem, ListItemText, Collapse, Avatar
} from "@mui/material"; import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { debounce } from "lodash";
import { useDispatch } from "react-redux";
import { CatalogActions } from "../../../../../Store/Slices/catalog/catalog.actions";
import { useAppDispatch } from "../../../../../Store";
import { LoaderComponentProps, withLoader } from "../../../../../AppComponents/Loader";
import AppPaginationComponent from "../../../../../AppComponents/Pagination/Pagination";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from "@mui/icons-material/Add";
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    open: boolean;
    onClose: () => void;
    node?: any;
    type?: any;
    onConfirm?: () => void;
    onSelectProducts?: any;
    sendSelectedData?: any;
    selectedProductsList?: any;
}
const AllCatalogService = (props: Props) => {
    const dispatch = useAppDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [localValues, setLocalValues] = useState<any>({
        itemsPerPage: { label: "10  per page", value: 10 },
        currentPage: 0,
        search: "",
    });
    const [catalogProductList, setCatalogProductList] = useState<any>([]);
    const [pagination, setPagination] = useState<any>();
    const [seletedIdsList, setSeletedIdsList] = useState<any>();
    const [localLoading, setLocalLoading] = useState<any>();
    const [selectedProducts, setSelectedProducts] = useState<any[]>(props?.selectedProductsList);
    console.log("node", props?.node);

    const handleConfirmSelection = () => {
        // If collections are selected, get all their products
        let allSelectedProducts = [...selectedProducts];

        props?.sendSelectedData(allSelectedProducts);
        if (props?.onSelectProducts) {
            props?.onSelectProducts(allSelectedProducts);
        }
        // // ✅ Call the passed debounce function
        if (props?.onConfirm) {
            props?.onConfirm();

        }
        props?.onClose();
    }
    useEffect(() => {
        let seletedIds = []
        if (props?.node && !props?.selectedProductsList) {
            if (props?.type === "product") {
                seletedIds = props?.node?.response?.[0]?.interactive?.action?.parameters?.thumbnail_product_retailer_id
            }
            if (props?.type === "catalogue") {
                seletedIds = props?.node?.response?.[0]?.interactive?.action?.product_retailer_id
            }
        }
        if (props?.selectedProductsList) {
            seletedIds = props?.selectedProductsList?.[0]?.retailer_id
        }
        fetchProducts(seletedIds)
    }, [localValues || props?.type])

    const fetchProducts = (seletedIds: any) => {
        setLocalLoading(true);
        const data = {
            limit: localValues?.itemsPerPage?.value,
            offset: localValues?.currentPage,
            search: localValues?.search,
            seletedIds: seletedIds
        };
        dispatch(CatalogActions.getCatalogProductList(data),
        ).then((save_result: any) => {
            setCatalogProductList(save_result?.payload?.data?.data);
            setPagination(save_result?.payload?.data?.pagination)
            setSelectedProducts(save_result?.payload?.data?.selectedProductList)
            setLocalLoading(false);

        })
            .catch((error: any) => { })
            .finally(() => {
                setLocalLoading(false);
            })
    }
    const debouncedSearch = React.useCallback(
        debounce((query: string) => {
            // Reset to first page when searching
            setLocalValues((prev: any) => ({
                ...prev,
                search: query,
                currentPage: 0
            }));
        }, 500),
        [localValues]
    );
    function handlePageChange(event: any, value: any) {
        setLocalValues({
            ...localValues,
            currentPage: value - 1,
        });
    }
    const handleChangeRowsPerPage = (value: any) => {
        setLocalValues({
            ...localValues,
            itemsPerPage: value,
            currentPage: 0,
        });
    };

    // Handle search input change
    const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setSearchQuery(query);
        debouncedSearch(query);
    };
    const handleSelectProduct = (product: any) => {
        setSelectedProducts([product])
    }
    const handleDelete = () => {
        setSelectedProducts([])
    }
    return (
        <Drawer
            anchor={"right"}
            open={props?.open}
            onClose={props?.onClose}
            sx={{
                '& .MuiDrawer-paper': {
                    width: "680px",
                    maxWidth: "680px",
                    boxSizing: 'border-box',
                }
            }}
        >
            <AppBar position="sticky" color="primary" sx={{ padding: 1 }} className="ignore-onClickOutside">
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h6" sx={{ color: "white" }}>
                        {"Select Product"}
                    </Typography>
                    <IconButton onClick={props?.onClose} sx={{ color: "white" }}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box sx={{ padding: 2, backgroundColor: "#f5f5f5", position: 'relative' }} className="ignore-onClickOutside">
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search Products..."
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    sx={{ backgroundColor: "#fff", borderRadius: '5px' }}
                />

            </Box>
            {selectedProducts?.length > 0 ? <Box style={{ marginLeft: "13px", padding: "12px" }} className="ignore-onClickOutside">
                <Chip
                    label={selectedProducts?.[0]?.name}
                    variant="outlined"
                    onDelete={handleDelete}

                />
            </Box> : null}
            <Box
                sx={{
                    overflowY: "auto",
                    // height: selectedProducts.length > 0 ? "50vh" : "calc(100vh - 140px)",
                    height: "calc(100vh - 140px)",
                    padding: 2,
                    backgroundColor: "#f9f9f9"
                }}
            >
                {localLoading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: "center",
                            alignItems: 'center',
                            position: "absolute",
                            top: "50%",
                            right: "50%"
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <Grid container spacing={2} className="ignore-onClickOutside">
                        {catalogProductList?.length > 0 ? (
                            catalogProductList?.map((product: any) => {
                                // ✅ Check if product is pre-selected
                                const productIds = selectedProducts.map(product => product.retailer_id);
                                const isDefaultSelected = productIds?.includes(product.retailer_id);
                                const selected = isDefaultSelected;
                                return (
                                    <Grid item xs={12} key={product.id} className="ignore-onClickOutside">
                                        <Card
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: 2,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                },
                                                border: selected ? '1px solid #4caf50' : 'none',
                                                backgroundColor: selected ? 'rgba(76, 175, 80, 0.05)' : 'white'
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 80, height: 80, borderRadius: "8px", marginRight: 2, objectFit: "cover" }}
                                                image={product.image_url}
                                                alt={product.name}
                                            />
                                            <CardContent sx={{ flexGrow: 1, padding: "8px 16px 8px 0" }}>
                                                <Typography variant="subtitle1">{product.name}</Typography>
                                                <Typography
                                                    variant="body1"
                                                    color="primary"
                                                    fontWeight="bold"
                                                    sx={{ marginTop: 1, display: "flex", alignItems: "center" }}
                                                >
                                                    {product.price}
                                                </Typography>
                                            </CardContent>
                                            <Button
                                                variant={selected ? "outlined" : "contained"}
                                                color={selected ? "success" : "primary"}
                                                size="small"
                                                startIcon={selected ? <CheckCircleIcon /> : <AddIcon />}
                                                onClick={() =>
                                                    handleSelectProduct(product)
                                                }
                                                // disabled={!selected && type === "multiple_product" && selectedProducts.length >= MAX_PRODUCTS}
                                                sx={{
                                                    minWidth: "120px",
                                                    borderRadius: "20px",
                                                    bgcolor: selected ? "rgba(46, 125, 50, 0.1)" : undefined
                                                }}
                                            >
                                                {selected ? "Selected" : "Select"}
                                            </Button>
                                        </Card>
                                    </Grid>
                                );
                            })
                        ) : (
                            <Typography sx={{ padding: 2, textAlign: "center", color: "gray", width: "100%" }}>
                                No products found.
                            </Typography>
                        )}

                        <Box style={{ width: "100%" }}>
                            <AppPaginationComponent
                                totalCount={pagination?.totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={localValues?.currentPage}
                                totalPages={pagination?.totalPages}
                                rowsPerPage={localValues?.itemsPerPage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Box>
                    </Grid>
                )}
            </Box>;
            <Box sx={{ padding: "12px 16px", borderTop: "1px solid #eee" }} className="ignore-onClickOutside">
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleConfirmSelection}
                >
                    Confirm Selection
                </Button>
            </Box>
        </Drawer>
    )
}
export default AllCatalogService;
